export default {
    text_1: "Moje firmy - DOFFERO®",
    text_2: "Moje firmy",
    text_3: "V tejto sekcií si môžeš pridať viacero firiem, pod ktorými chceš tvoriť ponuky. Následne ich môžeš používať pri vytváraní ponúk a budeme ti automaticky dopĺňať údaje.",
    text_4: "Vytvoriť novú firmu",
    text_5: "Názov firmy",
    text_6: "Zodpovedná osoba",
    text_7: "Upraviť položku",
    text_8: "Vymazať položku",
    text_9: "Určite?",
    text_10: "Naozaj chceš vymazať firmu?",
    text_11: "Nie",
    text_12: "Áno",
    text_13: "Firma bola úspešne vymazaná",
    text_14: "Firma bola úspešne vytvorená",
    text_15: "Firma bola úspešne upravená",
    text_16: 'Nová firma',
    text_17: 'Úprava firmy',
    text_18: 'NÁZOV FIRMY',
    text_19: 'Názov slúži pre tvoju evidenciu',
    text_20: 'ZODPOVEDNÁ / KONTAKTNÁ OSOBA',
    text_21: 'Firemné údaje',
    text_22: 'Niektoré údaje vieme vyplniť automaticky. Zadaj IČO alebo názov firmy.',
    text_23: 'Názov spoločnosti',
    text_24: 'IČO',
    text_25: 'DIČ',
    text_26: 'IČ DPH',
    text_27: 'ULICA A ČÍSLO sídla firmy',
    text_28: 'psč sídla firmy',
    text_29: 'MESTO sídla firmy',
    text_30: 'Uložiť firmu',

    text_31: "Vlož <b>logo firmy</b> presunutím alebo <span class='nahraj'>nahraj logo</span>",
    text_32: "Vlož <b>logo firmy</b> presunutím alebo <span class='nahraj'>nahraj logo</span>",
    text_33: "Vlož <b>logo firmy</b> presunutím alebo <span class='nahraj'>nahraj logo</span>",
    text_34: "Vymazať",
    text_35: "Stiahnuť",
    text_36: "Naozaj chcete vymazať logo?",
    text_37: "Je možné nahrať len jedno logo. Prosím, najskôr vymažte pôvodné.",
    text_38: "Iba ${extensions} súbory môžu byť nahrané.",
    text_39: "${name} je príliš veľký! Prosím, vyberte súbor do veľkosti ${size} MB.",
    text_40: "Logo firmy",
}